import React from 'react';

// Programme photos ship as WebP with a JPEG fallback. `image` in programs.json
// is the basename without an extension, so both variants derive from it.
function ProgramImage({ program, className }) {
    const base = `${process.env.PUBLIC_URL}/images/programs/${program.image}`;

    return (
        <picture className={className}>
            <source type="image/webp" srcSet={`${base}.webp`} />
            <img src={`${base}.jpg`} loading="lazy" alt={program.name} />
        </picture>
    );
}

export default ProgramImage;
